import type RBush from 'rbush';
import { useMemo } from 'react';

import { useMapContext } from '@/microfrontends/map/shared/context/MapContext';
import { type RBushItem } from '@/microfrontends/map/shared/types/Map';

type UseInitHotspotsLayerParams = {
  rbush: RBush<RBushItem>;
};

export function useInitHotspotsLayer({ rbush }: UseInitHotspotsLayerParams): YMaps.HotspotsLayer {
  const { ymaps, map } = useMapContext();

  return useMemo(() => new ymaps.HotspotsLayer({ map, rbush }), [map, rbush, ymaps.HotspotsLayer]);
}
